function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_627",
  "data-name": "Group 627",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_642",
  "data-name": "Path 642",
  d: "M94.825,85.007H76.269a.531.531,0,1,0,0,1.062H94.825a.531.531,0,0,0,0-1.062Z",
  transform: "translate(-75.738 -62.674)",
  fill: "#213368"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_643",
  "data-name": "Path 643",
  d: "M86.171,72.187a.531.531,0,0,0,.751,0l7.273-7.273a.531.531,0,0,0-.751-.75L87.077,70.53V52.077a.531.531,0,0,0-1.062,0V70.53l-6.367-6.367a.531.531,0,0,0-.751.75Z",
  transform: "translate(-76.737 -51.546)",
  fill: "#d71635"
}));

var SvgIconDownload = function SvgIconDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.618,
    height: 23.395,
    viewBox: "0 0 19.618 23.395",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconDownload.644f811c.svg";
export { ForwardRef as ReactComponent };